const lang ={

    en:{
        search:"Search",
        searchPlaceHolder:"What Would You like to watch Today?"
    },
    hi:{
        search:"खोज",
        searchPlaceHolder:"आज आप क्या देखना चाहेंगे?"
    },
    cg:{
        search:"खोजबीन",
        searchPlaceHolder:"आज काला देखे के मन हे ?"
    }
}


export default lang;